import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

import { MenuItem as MenuItemType } from 'ichraDecisionTool/common/MenuItem'

import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'

import HeaderUserSection from 'common/components/layout/HeaderUserSection'
import InternalToolsHeaderSwitch from 'common/components/navigation/InternalToolsHeaderSwitch/InternalToolsHeaderSwitch'

import { Layout, Menu, MenuItem } from 'common/components'

import { NaviationMapping, menu, navigationPathMapping } from './Routes'

import './IchraDecisionTool.less'

interface IchraDecisionToolsProps {
  children?: ReactNode
  user: User
}

const IchraDecisionToolsWrapper = ({ children, user }: IchraDecisionToolsProps) => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { t: translate } = useTranslation('ichra-decision-tool')
  const [activeKey, setActiveKey] = useState<string[] | undefined>()

  const goToPath = (path: string) => {
    history.push(path)
  }

  useEffect(() => {
    const split = pathname.split('/')[2]
    const res = navigationPathMapping.get(split)
    setActiveKey(res ? [res.toString()] : [NaviationMapping.Prospects.toString()])
  }, [pathname])

  return (
    <Layout>
      <Menu selectedKeys={activeKey} mode="horizontal">
        <InternalToolsHeaderSwitch defaultValue={Permissions.AccessIchraDecisionTools} />

        {menu
          .sort((first, second) => first.key - second.key)
          .map((item: MenuItemType) => (
            <MenuItem key={item.key} onClick={() => goToPath(item.path)}>
              {translate(item.name)}
            </MenuItem>
          ))}

        <MenuItem key={10} className="header_right_section  mr-64 no_hover_styles ">
          <div className="flex__space_between flex__space_between_centered ">
            <HeaderUserSection user={user} userInfo={user} showProfile={false} />
          </div>
        </MenuItem>
      </Menu>
      <Layout className="dashboard_body">
        <Layout className="dashboard-layout-content">{children}</Layout>
      </Layout>
    </Layout>
  )
}

export default IchraDecisionToolsWrapper
